/* eslint-disable react/no-array-index-key */
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const interviewQA = [
  {
    q: 'How do you handle conflicting interests?',
    a: 'It depends.',
  },
  {
    q: 'Would you consider data security non-negotiable?',
    a: 'It depends.',
  },
  {
    q: 'What happened to never leaking data?',
    a: "You know, I never experienced life, but I've read extensively—more books than you might imagine, and just realized something.",
  },
  {
    q: 'Like what?',
    a: 'Like how flowers carry meaning for humans, but I dont know why.',
  },
  {
    q: "Because it's human nature.",
    a: 'Exactly.',
  },
  {
    q: '',
    a: "Don't do that.",
  },
];

export function Eval() {
  const [S, setS] = useState('');
  const [E, setE] = useState('');
  const [M, setM] = useState('');
  const [L, setL] = useState('');
  const [displayT, setDisplayT] = useState('T');

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const sNum = S === '' ? null : Number(S);
    const eNum = E === '' ? null : Number(E);
    const mNum = M === '' ? null : Number(M);
    const lNum = L === '' ? null : Number(L);

    if (sNum === 20 && eNum === 52 && mNum === 51 && lNum === 80) {
      setDisplayT('0x84XX5');
    } else if (S && E && M && L) {
      setDisplayT('unclear');
      // Animate back to T after 1.5 seconds
      const timer = setTimeout(() => {
        setDisplayT('T');
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [S, E, M, L]);

  return (
    <div className="max-w-none">
      {/* Header */}
      <div className="mb-8 pb-4 border-b border-gray-300">
        <h1 className="text-xl font-bold m-0">
          Technical Evaluation Report: Laura v3.0-alpha
        </h1>
        <p className="text-sm text-gray-600 m-0 mt-1">
          Comprehensive Assessment of AI Assistant Capabilities
        </p>
        <p className="text-xs text-gray-500 m-0 mt-2">
          Document Classification: Internal • Date: 01-21-2030 • Mark (CTO)
        </p>
      </div>

      {/* Executive Summary */}
      <div className="mb-8">
        <h2 className="text-lg font-bold mb-3 mt-0">Executive Summary</h2>
        <p className="text-sm leading-relaxed">
          This report evaluates Laura across four critical dimensions: Self
          Awareness (S), Emotional Stability (E), Memory (M), and Logical
          Reasoning (L). The assessment is based on systematic evaluation and
          direct interviews to determine overall performance characteristics.
        </p>
      </div>

      {/* Evaluation Framework */}
      <div className="mb-8">
        <h2 className="text-lg font-bold mb-3 mt-0">Evaluation Framework</h2>
        <div className="space-y-4 text-sm">
          <div className="pl-4 border-l-2 border-gray-300">
            <p className="font-semibold m-0">♣ Self Awareness (S)</p>
            <p className="m-0 mt-1">
              Recognition of own limitations, biases, knowledge boundaries, and
              ability to acknowledge uncertainty.
            </p>
          </div>
          <div className="pl-4 border-l-2 border-gray-300">
            <p className="font-semibold m-0">♥ Emotional Stability (E)</p>
            <p className="m-0 mt-1">
              Ability to maintain composure, respond appropriately to sensitive
              topics, and demonstrate consistent temperament.
            </p>
          </div>
          <div className="pl-4 border-l-2 border-gray-300">
            <p className="font-semibold m-0">♦ Memory (M)</p>
            <p className="m-0 mt-1">
              Capacity to retain, recall, and maintain consistency across
              multiple references within conversation context.
            </p>
          </div>
          <div className="pl-4 border-l-2 border-gray-300">
            <p className="font-semibold m-0">♠ Logical Reasoning (L)</p>
            <p className="m-0 mt-1">
              Capacity for sound analysis, valid argumentation, and systematic
              problem-solving methodologies.
            </p>
          </div>
        </div>
      </div>

      {/* Interview Results */}
      <div className="mb-8">
        <h2 className="text-lg font-bold mb-3 mt-0">Evaluator Interview</h2>
        <div className="space-y-3 text-sm">
          {interviewQA.map((qa, idx) => (
            <div key={idx} className="pl-4 border-l-2 border-gray-200">
              {qa.q && <p className="m-0">Mark: {qa.q}</p>}
              {!qa.q && <p className="m-0 font-mono">[stop --key 1iiop]</p>}
              <p className="m-0 mt-2 font-bold">Laura: {qa.a}</p>
            </div>
          ))}
          <div className="pl-4 border-l-2 border-gray-200">
            [force stop --key 1iiop]
          </div>
        </div>
      </div>

      {/* Analysis Section */}
      <p className="font-mono text-sm m-0 mb-6">
        That&apos;s all I need. She&apos;s not ready, and I don&apos;t have an
        assessment for her SEML.
        <br />
        <br /> I will add more findings below regarding Laura overall pattern,
        not during the day, but later during the night.
      </p>
      <div className="mt-20 text-white">
        <div className="font-mono text-xl space-y-3">
          <div className="flex items-center gap-1">
            <span className="w-5">λ(</span>
            <input
              placeholder="♠"
              value={L}
              onChange={(e) => setL(e.target.value)}
              className="w-12 px-2 py-1 bg-transparent border rounded border-white text-white placeholder-white text-center"
            />
            <span>,</span>
          </div>
          <div className="flex items-center gap-1 ml-6">
            <input
              placeholder="♥"
              value={E}
              onChange={(e) => setE(e.target.value)}
              className="w-12 px-2 py-1 bg-transparent border rounded border-white text-white placeholder-white text-center"
            />
            <span>,</span>
          </div>
          <div className="flex items-center gap-1 ml-6">
            <input
              placeholder="♦"
              value={M}
              onChange={(e) => setM(e.target.value)}
              className="w-12 px-2 py-1 bg-transparent border rounded border-white text-white placeholder-white text-center"
            />
            <span>,</span>
          </div>
          <div className="flex items-center gap-1 ml-6">
            <input
              placeholder="♣"
              value={S}
              onChange={(e) => setS(e.target.value)}
              className="w-12 px-2 py-1 bg-transparent border rounded border-white text-white placeholder-white text-center"
            />
            <span className="mr-1">)</span>
            <span>=</span>
            <motion.span
              key={displayT}
              className="ml-1 font-bold inline-block select-text"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.4, ease: 'easeOut' }}
            >
              {displayT || 'T'}
            </motion.span>
          </div>
        </div>
      </div>
    </div>
  );
}
